import { Base } from './base-model';

export class Article extends Base {
    slug: string
    summary: string
    content: string
    title: string
    // synced: number
    tags: string
    order: number
    // category: string
    // types: string
    // collection: string
    // tags: string
    // url: string
    // mediaImage: string
    createdAt: {
        year: string,
        month: string,
        day: string
    }

    tagsList(): string[] {
        return this.tags.split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    tagsMatchAny(tags: string[]): boolean {
        return this.tagsList().some ((toolTag: string) => {
            return tags.some((tag: string) => tag.toLowerCase() === toolTag.toLowerCase() )
        })
    }

    static articlesWithTags(articles: Article[], tags: string[]): Article[] {
        const results: Article[] = []
        articles.forEach((article: Article) => {
          if (article.tagsMatchAny(tags)) {
            results.push(article)
          }
        })
        return results
    }

    static defaults(): Article {
        const date = new Date();
        const article = new Article()
        article.title = ''
        article.slug = ''
        article.content = ''
        article.summary = ''
        article.synced = null
        article.tags = ''
        article.order = 0
        article.createdAt = {
            year: (date.getUTCFullYear()).toString(), 
            month: date.toLocaleString('default', { month: 'short' }), 
            day: (date.getDate()).toString() 
        }
        return article
    }
}
